import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { CustomReportPreference } from '@models/reporting/CustomReportPreference';
import { AwaiterService } from '@services/awaiter.service';
import { CDK_IMPORTS } from '@utils/standalone-imports';
import { IconSanitizerService, ModalComponentBase, SnackbarNotificationService } from 'ngx-lib';

interface IModalShareReportParameters {
    reportService: any;
    filterParameters: any;
    reportData: any;
    hiddenColumns?: string[];
    groupingColumns?: string[];
    orderColumns?: string[];
    customReportPreferences?: CustomReportPreference[];
}
@Component({
    selector: 'app-modal-report-share',
    templateUrl: './modal-report-share.component.html',
    styleUrls: ['./modal-report-share.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [...CDK_IMPORTS]
})
export class ModalReportShareComponent
    extends ModalComponentBase<IModalShareReportParameters, undefined>
    implements OnInit
{
    shareLInk: string;
    isLoading: boolean;

    closeIcon: SafeHtml;

    constructor(
        private readonly awaiter: AwaiterService,
        private readonly snackbarNotificationService: SnackbarNotificationService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        super();
        this.shareLInk = 'testes';
        this.closeIcon = this.iconSanitizer.getIcon('closeModal');
        this.isLoading = true;
    }

    async ngOnInit(): Promise<void> {
        await this.setSharedReportLink();
    }

    async setSharedReportLink(): Promise<void> {
        await this.awaiter.awaitAction(
            'Running template...',
            async () => {
                const res = await this.parameters?.reportService.shareReport({
                    name: this.parameters?.reportData?.name,
                    reportTemplateId: this.parameters?.reportData.reportTemplateId
                        ? this.parameters.reportData.reportTemplateId
                        : this.parameters?.reportData.id,
                    filterParameters: this.parameters?.filterParameters,
                    isFavorite: this.parameters?.reportData.isFavorite,
                    isPublic: this.parameters?.reportData.isPublic,
                    hiddenColumns: this.parameters?.hiddenColumns,
                    groupingColumns: this.parameters?.groupingColumns,
                    orderColumns: this.parameters?.orderColumns,
                    customReportPreferences: this.parameters?.customReportPreferences
                });
                this.shareLInk = res.url;
            },
            (loading) => (this.isLoading = loading)
        );
    }

    async copyToClipboard(): Promise<void> {
        if (!this.shareLInk) return;
        try {
            await navigator.clipboard.writeText(this.shareLInk);
            this.snackbarNotificationService.success('Link copied to clipboard');
        } catch {
            this.snackbarNotificationService.error('An error occurred while trying to copy link to clipboard');
        }
    }
}
